export const TEMPLATE_NAMES = {
  PDP: 'AccommodationPage',
};

export const CANARY_RELEASE_PDP_ID = [
  // PRODUCTION
  'afaab3a4-7cb8-45bf-bf7e-8b7fef1e4421',
  'f9c33ad0-687a-47f1-b00b-92486d5e3726',
  'f5562307-c1eb-488f-ac14-808f21448cca',
  '4ca577c4-af47-4822-9fab-07eb5258a157',
  '36f18c2d-0a4a-40cc-b6ba-b7628ab008bd',

  // ACCEPTANCE
  'fa675f18-7c98-46aa-bc7a-aa60d0af32a4', // The Three Corners Sunny Beach Resort
  '41e469cd-ed51-4f91-9f55-2048e8a79b4b', //Hotel Casa Blue Beach Resort
  'ad495a5d-175a-4d49-b2d0-01ac7f99ecc1', // The Three Corners Sea Beach Resort
  '7960bb2b-7093-47c5-bb91-8c837ec38199', // The Three Corners Fayrouz Plaza Beach Resort
  '5e5a0414-bae7-4fb9-9ac6-86ddba393110', // Cooks Club adults only
  'f13044cb-bfcf-4163-941c-54f4a649f96c', // three corners rihana
];

export const SEO_TEST_PDP_ID = [
  // PRODUCTION
  '0e50c30a-b85f-4d98-8ce4-09e391b8fd50', // Hotel Stamos Plus
  '81f480de-b0ed-4c2e-88b7-173e23bed247', // Hotel Tigaki Beach
  'd236e281-d859-4414-8d88-c94bd30c46fb', // Hotel Naftilos Boutique
  '2a60d911-50d8-434b-bdb2-e6448e154b5f', // Park Hotel Casimiro
  '49e3f5ca-a520-4711-99da-d3c85a082b0d', // Hotel Mitsis Family Village

  // ACCEPTANCE
  '4db90a69-9d07-42e8-9b61-6a7a95397ddd', // Hotel Sentido Mamlouk Palace Resort - /vakantie/egypte/rode-zee/hurghada/hotel-sunrise-select-mamlouk-palace-resort
  'b5d756a5-a4f1-47fb-a573-291cb7c97a20', // Hotel SUNRISE Select Royal Makadi Aqua Resort - /vakantie/egypte/rode-zee/makadi-bay/hotel-sunrise-select-royal-makadi-aqua-resort
];
